import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

export default function BranchDetail() {
  const [branchData, setBranchData] = useState(null);
  const { branchID } = useParams(); // Get branchID from the URL params
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBranchData = async () => {
      try {
        const response = await axios.get(`https://fboothapi.azurewebsites.net/api/branch/${branchID}`);
        setBranchData(response.data);
      } catch (error) {
        console.error('Error fetching branch data:', error);
      }
    };

    fetchBranchData();
  }, [branchID]);

  if (!branchData) {
    return <div>Loading...</div>;
  }

  const handleBoothClick = (boothID) => {
    navigate(`/boothdetail/${boothID}`); // Navigate to BoothDetail component
  };

  return (
    <div className="container mx-auto py-8">
      {/* Back Button */}
      <button 
        onClick={() => navigate(-1)}
        className="mb-4 text-blue-500 hover:text-blue-700"
      >
        ← Back 
      </button>

      <div className="flex gap-8 mb-8">
  {/* Branch Photos */}
  <div className="w-full md:w-1/2">
    <div className="mb-4">
      <img 
       className="w-[600px] h-[500px] rounded object-cover"
        src={branchData.branchPhotos[0]?.branchPhotoUrl || 'https://via.placeholder.com/300x300'} 
        alt={branchData.branchName}
      />
    </div>
    <div className="grid grid-cols-4 gap-4">
      {branchData.branchPhotos.slice(1, 5).map((photo, index) => (
        <div key={index}>
          <img 
            className="h-64 w-full rounded-lg object-cover" 
            src={photo.branchPhotoUrl || 'https://via.placeholder.com/150x150'} 
            alt={`Branch ${index + 1}`}
          />
        </div>
      ))}
    </div>
  </div>

  {/* Branch Overview */}
  <div className="w-full md:w-3/5 p-8 bg-white rounded-lg shadow-lg">
  <h2 className="text-4xl font-extrabold text-gray-900 mb-6">{branchData.branchName}</h2>
  
  <h3 className="text-2xl font-bold text-gray-800 mb-4">Overview</h3>
  <div className="space-y-6">
    <div className="flex items-center">
      <span className="font-bold text-gray-600 w-1/4 flex items-center">
        <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 3a1 1 0 01.993.883L11 4v12a1 1 0 01-1.993.117L9 16V4a1 1 0 011-1z" />
          <path d="M6.293 7.293a1 1 0 011.414 0L10 9.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" />
        </svg>
        Address:
      </span>
      <span className="ml-2 text-gray-800">{branchData.address}</span>
    </div>
    <div className="flex items-center">
      <span className="font-bold text-gray-600 w-1/4 flex items-center">
        <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 3a1 1 0 01.993.883L11 4v12a1 1 0 01-1.993.117L9 16V4a1 1 0 011-1z" />
          <path d="M6.293 7.293a1 1 0 011.414 0L10 9.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" />
        </svg>
        Town:
      </span>
      <span className="ml-2 text-gray-800"> {branchData.town}</span>
    </div>
    <div className="flex items-center">
      <span className="font-bold text-gray-600 w-1/4 flex items-center">
        <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 3a1 1 0 01.993.883L11 4v12a1 1 0 01-1.993.117L9 16V4a1 1 0 011-1z" />
          <path d="M6.293 7.293a1 1 0 011.414 0L10 9.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" />
        </svg>
        City:
      </span>
      <span className="ml-2 text-gray-800">{branchData.city}</span>
    </div>
    <div className="flex items-center">
      <span className="font-bold text-gray-600 w-1/4 flex items-center">
      <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3.293l5 5V13h2V8.293a1 1 0 00-.293-.707l-7-7A1 1 0 007 1v2H5a2 2 0 00-2 2v10a2 2 0 002 2h4v2a1 1 0 001.707.707l7-7A1 1 0 0019 10V7.414a2 2 0 00-.586-1.414l-7-7A2 2 0 009 0H4a2 2 0 00-2 2v12a2 2 0 002 2h2v-2H4a2 2 0 01-2-2V4a2 2 0 012-2h2V1a1 1 0 011-1h5z" />
          </svg>
        Status:
      </span>
      <span className="ml-2 text-gray-800">{branchData.status}</span>
    </div>
    <div className="flex items-center">
      <span className="font-bold text-gray-600 w-1/4 flex items-center">
      <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 4.5A5.5 5.5 0 0114.5 10h-1A4.5 4.5 0 009 5.5V4.5zm1 6.5a1 1 0 00-1-1H8.5a1 1 0 100 2H9a1 1 0 001-1zM4 4a2 2 0 01.91.213 4.992 4.992 0 00-1.105 1.884L3 6.7V6h1V4zM2 9.5v1h1v-1H2zm1 3v1h1v-1H3zm0 2.5v1h1v-1H3zM9 18.5V17h1v1.5a2 2 0 01-.91.213 4.992 4.992 0 001.105-1.884L10 16.7V17h-1v1.5z" />
            <path d="M6 5a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V5z" />
            <path fillRule="evenodd" d="M4 9a1 1 0 011-1h10a1 1 0 011 1v8a1 1 0 01-1 1H5a1 1 0 01-1-1V9zm10-4a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h8z" clipRule="evenodd" />
          </svg>
        Opening Time:
      </span>
      <span className="ml-2 text-gray-800">{`${branchData.openingTime}`}</span>
    </div>
    <div className="flex items-center">
      <span className="font-bold text-gray-600 w-1/4 flex items-center">
        <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 2a1 1 0 01.993.883L11 3v2h7a1 1 0 011 .993v9.014a1 1 0 01-.883.993L18 16h-1v2a1 1 0 01-.883.993L16 19h-5.072a6.96 6.96 0 01-1.732-2H16v-4h-6a1 1 0 01-.993-.883L9 12V4a1 1 0 01.883-.993L10 3h4a1 1 0 01.993.883L15 4v1h1.292l-4.646-4.646a.5.5 0 00-.708.708L15.293 5H10V4a1 1 0 01.883-.993L11 3H4a1 1 0 01-.993-.883L3 2a1 1 0 01.883-.993L4 1h6zM3 6a1 1 0 011 .993v1.014a1 1 0 01-.883.993L3 9H2V7.014a1 1 0 01.883-.993L3 6h1V5H3zm0 7v2h1v-2H3zm0 3v2h1v-2H3zm2-5h1V9H5v2zm0 3v2h1v-2H5zm10-7h1v1h-1V7zm0 3v2h1v-2h-1zm0 3v2h1v-2h-1z" />
        </svg>
        Closing Time:
      </span>
      <span className="ml-2 text-gray-800">{`${branchData.closingTime}`}</span>
    </div>
  </div>
</div>

</div>


      {/* Booths list */}
      <div className="mt-8">
        <h3 className="text-2xl font-bold text-gray-800">Booths</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
          {branchData.booths.map(booth => (
            <div 
              key={booth.boothID} 
              className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transform transition-transform hover:scale-105"
              onClick={() => handleBoothClick(booth.boothID)}
            >
              <img
                src={booth.boothPhotos[0]?.boothPhotoUrl || 'https://via.placeholder.com/300x200'}
                alt={booth.boothName}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg font-bold">{booth.boothName}</h3>
                <p className="text-gray-600">Background Color: {booth.backgroundColor}</p>
                <p className="text-gray-600">Concept: {booth.concept}</p>
                <p className="text-gray-600">Max people: {booth.peopleInBooth}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
